import type { TourSpec } from '../data/tours'
import { useText } from '@kkf/design'

export interface SpecBlockProps {
  items: TourSpec[]
  /**
   * Adds the "to be confirmed" note. The commercial facts on every tour are placeholders,
   * and a booking page that shows a made-up price is quoting rather than illustrating.
   */
  pending?: boolean
}

/**
 * The at-a-glance strip on a tour page: duration, difficulty, group size, season, price.
 *
 * App-local, styles in `app_design`'s `sections/_garage.scss` — see `TourCard` for why.
 */
export function SpecBlock({ items, pending = false }: SpecBlockProps) {
  const s = useText()
  return (
    <div className="ul-spec-block">
      <dl className="ul-spec-block-grid">
        {items.map((item) => (
          <div className="ul-spec-block-item" key={s(item.term)}>
            <dt>{s(item.term)}</dt>
            <dd>{s(item.detail)}</dd>
          </div>
        ))}
      </dl>
      {pending && (
        <p className="ul-spec-block-note">
          Duration, difficulty and price above are indicative. Nothing is confirmed until we
          have written to you with the figures for your dates and your group.
        </p>
      )}
    </div>
  )
}
